import Client from './client';

export default class MarketingGatewayGoogleConnections extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/google`, options);
  }

  put(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/google`, {
      ...options,
       method: 'PUT',
    });
  }

  delete(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/google`, {
      ...options,
       method: 'DELETE',
    });
  }

  putAccount(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/google/account`, {
      ...options,
       method: 'PUT',
    });
  }

}
